import React from 'react';
import {useSelector} from 'react-redux';
import HappyPlayIcon from '@stencil/icons/src/HappyPlayIcon/HappyPlayIcon';
import {showVideoDwebSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';
import * as S from '../CaptivativeImagesGrid.styles';

const CaptivatePotraitImg = ({
  imgUrl = '',
  updateCarouselState = imageNo => {},
  imageNo = 1,
  isVideo = false,
  thumbnailUrl = '',
}) => {
  const showDwebVideos = useSelector(showVideoDwebSelector);
  return showDwebVideos && isVideo ? (
    <S.VideoLandscapeImageWrapper onClick={() => updateCarouselState({imageNo, isOpen: true})}>
      <S.CaptivatePotraitImage src={thumbnailUrl || imgUrl} width={'100%'} />
      <HappyPlayIcon />
    </S.VideoLandscapeImageWrapper>
  ) : (
    <S.CaptivatePotraitImage
      src={imgUrl}
      onClick={() => updateCarouselState({imageNo, isOpen: true})}
    />
  );
};

export default CaptivatePotraitImg;
